import { render, staticRenderFns } from "./PostForm.vue?vue&type=template&id=cb24ed6a&scoped=true&"
import script from "./PostForm.vue?vue&type=script&lang=js&"
export * from "./PostForm.vue?vue&type=script&lang=js&"
import style0 from "./PostForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PostForm.vue?vue&type=style&index=1&id=cb24ed6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb24ed6a",
  null
  
)

export default component.exports